import { render, staticRenderFns } from "./shipin.vue?vue&type=template&id=63109c22&scoped=true&"
import script from "./shipin.vue?vue&type=script&lang=ts&"
export * from "./shipin.vue?vue&type=script&lang=ts&"
import style0 from "./shipin.vue?vue&type=style&index=0&id=63109c22&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63109c22",
  null
  
)

export default component.exports